type SiteThemeName = 'particulier' | 'pro'

export function useSiteTheme() {
    const route = useRoute()

    const currentTheme = computed<SiteThemeName>(() => {
        return route.path.startsWith('/entreprises') ? 'pro' : 'particulier'
    })

    const isPro = computed(() => currentTheme.value === 'pro')

    const htmlClass = computed(() => {
        return isPro.value ? 'theme-pro' : 'theme-particulier'
    })

    const theme = computed(() => {
        if (isPro.value) {
            return {
                name: 'pro',
                htmlClass: 'theme-pro',
                accentText: 'text-orange-700',
                accentBg: 'bg-orange-700',
                accentBgHover: 'hover:bg-red-700',
                accentBorder: 'border-orange-500',
                accentBorderHover: 'hover:border-orange-500',
                accentTextHover: 'hover:text-orange-700',
                buttonPrimary: 'bg-gradient-to-r from-red-600 to-orange-700 text-white hover:brightness-90',
                buttonSecondary: 'border-orange-500 text-orange-700 hover:bg-orange-700 hover:text-white',
                iconBox: 'bg-orange-50 text-orange-700'
            } as const
        }

        return {
            name: 'particulier',
            htmlClass: 'theme-particulier',
            accentText: 'text-sky-700',
            accentBg: 'bg-sky-700',
            accentBgHover: 'hover:bg-sky-800',
            accentBorder: 'border-sky-600',
            accentBorderHover: 'hover:border-sky-600',
            accentTextHover: 'hover:text-sky-700',
            buttonPrimary: 'bg-sky-700 hover:bg-sky-800 text-white',
            buttonSecondary: 'border-sky-600 text-sky-700 hover:bg-sky-700 hover:text-white',
            iconBox: 'bg-sky-50 text-sky-700'
        } as const
    })

    // PAS de useHead ici

    return {
        currentTheme,
        htmlClass,
        isPro,
        theme
    }
}